import { gql } from '@apollo/client';

export const ALL_VERIFICATION_PROFILE_FIELDS = gql`
  fragment AllVerificationProfileFields on VerificationProfile {
    id
    projectId
    espAccountId
    profileId
  }
`;

export const RELEVANT_TELNYX_VERIFY_PROFILE_FIELDS = gql`
  fragment RelevantTelnyxVerifyProfileFields on TelnyxVerifyProfile {
    id
    language
    name
    sms {
      defaultVerificationTimeoutSecs
    }
    updatedAt
  }
`;

export const RELEVANT_TWILIO_VERIFICATION_SERVICE_FIELDS = gql`
  fragment RelevantTwilioVerificationServiceFields on TwilioVerificationService {
    id
    name
    updatedAt
    codeLength
  }
`;
